import { useTranslation } from "react-i18next";

import { ITranslationKeys } from "services/translation";

export function Translate({ value }: { value: ITranslationKeys }) {
  const [t] = useTranslation();

  return <>{t(value)}</>;
}
